import moment from 'moment';
import Cookies from 'universal-cookie';

export const syncCalendarWithSelectedDate = (calendarRef, dateRange) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const calendarApi = calendarRef?.current?.getApi();

  const startDate = moment.tz(dateRange?.startDate, timezone).format('YYYY-MM-DD');

  calendarApi?.gotoDate(startDate);
};
